import SharedNavbar from '../../components/feature/SharedNavbar';
import SharedFooter from '../../components/feature/SharedFooter';
import FloatingCallButton from '../../components/feature/FloatingCallButton';
import Hero from './components/Hero';
import ServicesGrid from './components/ServicesGrid';
import CTABanner from './components/CTABanner';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <Hero />
      <ServicesGrid />
      <CTABanner />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}